module.exports = __webpack_public_path__ + "static/media/close.fb267032.svg";